import { useState } from 'react';
import type { FaqItem } from '@/types/content';

interface FaqAccordionProps {
  items: readonly FaqItem[];
}

export default function FaqAccordion({ items }: FaqAccordionProps) {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <div className="divide-y divide-background-200 border border-background-200 rounded-lg overflow-hidden bg-background-50">
      {items.map((item, index) => {
        const isOpen = open === index;
        return (
          <div key={item.q}>
            <button
              type="button"
              onClick={() => setOpen(isOpen ? null : index)}
              aria-expanded={isOpen}
              className="w-full flex items-center justify-between gap-4 px-4 md:px-5 py-4 text-left hover:bg-background-100 transition-colors cursor-pointer"
            >
              <h3 className="font-heading font-bold text-sm md:text-base text-foreground-950">{item.q}</h3>
              <span
                className={`w-7 h-7 shrink-0 rounded-full flex items-center justify-center text-lg transition-colors ${
                  isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-700'
                }`}
              >
                <i className={isOpen ? 'ri-subtract-line' : 'ri-add-line'} />
              </span>
            </button>
            {isOpen && (
              <div className="px-4 md:px-5 pb-5 -mt-1">
                <p className="text-sm leading-7 text-foreground-600">{item.a}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}